module.exports = __webpack_public_path__ + "cde1846abd4383ed451c57a308bd7657.svg";